import * as c from 'utils/fieldConstants';
import {
  fetchCampaignLabelsQuery,
  fetchListQuery,
  fetchListsQuery,
  fetchMessageChannelsQuery,
  fetchMessageTypesQuery,
} from './SingleSelectDropdown.queries';

export const QUERY_TYPES = {
  CAMPAIGN_LABELS: 'CAMPAIGN_LABELS',
  LISTS: 'LISTS',
  MESSAGE_TYPES: 'MESSAGE_TYPES',
  MESSAGE_CHANNELS: 'MESSAGE_CHANNELS',
};

export const queryConfigMap = {
  [QUERY_TYPES.CAMPAIGN_LABELS]: {
    isPaginated: false,
    gqlQuery: fetchCampaignLabelsQuery,
    resultsPath: 'campaignLabels',
    fields: [c.CAMPAIGN_LABEL],
  },
  [QUERY_TYPES.LISTS]: {
    isPaginated: true,
    gqlQuery: fetchListsQuery,
    singleQuery: fetchListQuery,
    resultsPath: 'lists.results',
    fields: [
      c.LIST_MEMBERSHIP_SINGLE,
      c.LIST_MEMBERSHIP,
      c.USER_LIST_MEMBERSHIP,
      c.USER_LIST_MEMBERSHIP_SINGLE,
    ],
  },
  [QUERY_TYPES.MESSAGE_TYPES]: {
    isPaginated: false,
    gqlQuery: fetchMessageTypesQuery,
    resultsPath: 'messageTypes',
    fields: [c.SUBSCRIBED_MESSAGE_TYPES, c.UNSUBSCRIBED_MESSAGE_TYPES, c.MESSAGE_TYPE],
  },
  [QUERY_TYPES.MESSAGE_CHANNELS]: {
    isPaginated: false,
    gqlQuery: fetchMessageChannelsQuery,
    resultsPath: 'messageChannels',
    fields: [c.UNSUBSCRIBED_CHANNELS, c.MESSAGE_CHANNEL],
  },
};

/**
 * Map of the fields to the query types.  EG:
 *
 * ```
 * {
 *   [c.CAMPAIGN_LABEL]: QUERY_TYPES.CAMPAIGN_LABELS,
 *   [c.LIST_MEMBERSHIP_SINGLE]: QUERY_TYPES.LISTS,
 *   ...
 * }
 * ```
 */
export const fieldTypeToQueryTypeMap = Object.entries(queryConfigMap).reduce(
  (acc, [key, { fields = [] }]) => ({
    ...acc,
    ...fields.reduce((fieldAcc, field) => ({ ...fieldAcc, [field]: key }), {}),
  }),
  {},
);
